import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SelectItem } from 'primeng/primeng';

import { Filter } from '../../shared/filter';
import { HttpErrorHandler } from '../../shared/http-error-handler';

import { Ship } from '../../_models/ship';
import { ShipService } from '../../_services/ship.service';

import { TideFilter } from '../../_models/tide';

@Component({
  selector: 'app-tide-filter',
  templateUrl: './tide-filter.component.html',
  styleUrls: ['./tide-filter.component.sass'],
})
export class TideFilterComponent extends Filter implements OnInit {
  @Input() filterParams: any[];
  @Output() onApplyFilter = new EventEmitter<string>();

  form: FormGroup;
  filter: TideFilter;

  ships: SelectItem[] = [];
  selectedShips: Ship[];
  startDate: Date;
  endDate: Date;

  constructor(private fb: FormBuilder, private shipService: ShipService, private router: Router, private httpErrorHandler: HttpErrorHandler) {
    super();
    this.form = fb.group({
      code: [''],
      ship: [''],
      start_date: [''],
      end_date: [''],
    });
  }

  ngOnInit() {
    this.filter = new TideFilter(this.filterParams);
    if (this.filter.start_date) {
      this.startDate = new Date(this.filter.start_date);
    }

    if (this.filter.end_date) {
      this.endDate = new Date(this.filter.end_date);
    }
    this.getShips();
  }

  getShips() {
    this.shipService.list(1, 1000, '', '').subscribe(
      (response) => {
        this.ships = this.parseDropdownResults(response.results, new Ship(), 'name', false);
        this.selectedShips = this.selectMultipleDropdownItems(response.results, this.filter.ship);
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }

  onSubmit() {
    this.filter.start_date = '';
    if (this.startDate) {
      this.startDate.setHours(23);
      this.filter.start_date = this.startDate.toISOString().substring(0, 10);
    }

    this.filter.end_date = '';
    if (this.endDate) {
      this.endDate.setHours(23);
      this.filter.end_date = this.endDate.toISOString().substring(0, 10);
    }

    this.filter.ship = [];
    if (this.selectedShips) {
      this.filter.ship = this.selectedShips;
    }

    if (this.filterParams['o'] !== undefined) {
      this.filter['o'] = this.filterParams['o'];
    }

    this.router.navigate(['/tides', TideFilter.serializeRouterParams(this.filter)]);
  }
}



// WEBPACK FOOTER //
// ./src/app/tides/tide-filter/tide-filter.component.ts